import { Box, Tooltip } from '@mui/material'

export interface DataRecord {
  key: string
  name: string
  value: string | number | boolean
  hidden?: boolean
}
interface GenericInformationTooltipProps {
  data: DataRecord[]
  placement?:
    | 'bottom'
    | 'top'
    | 'left'
    | 'right'
    | 'bottom-start'
    | 'bottom-end'
    | 'top-start'
    | 'top-end'
    | 'left-start'
    | 'left-end'
    | 'right-start'
    | 'right-end'
  isTooltipDisabled?: boolean
}
const GenericInformationTooltip: React.FC<GenericInformationTooltipProps> = ({
  data,
  children,
  placement = 'top-start',
  isTooltipDisabled = false,
}) => {
  const renderTooltipContent = () => {
    return (
      <Box sx={{ p: 1, maxWidth: '300px' }}>
        {data.map(
          record =>
            !record.hidden && (
              <Box key={record.key}>
                <strong>{record.name} : </strong> {record.value.toString()}
              </Box>
            ),
        )}
      </Box>
    )
  }

  return (
    <Tooltip title={renderTooltipContent()} placement={placement} arrow disableHoverListener={isTooltipDisabled}>
      <Box>{children}</Box>
    </Tooltip>
  )
}

export default GenericInformationTooltip
